module.exports = __webpack_public_path__ + "static/media/crvBUSD-logo.2a8cf434.png";